import { Component, OnInit, Directive, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Activity1710Service } from './activity1710.service';
import { IMAGE_BASE__URL } from '../core/services/CusHttp';


@Component( {
  selector: 'app-activity1710',
  templateUrl: './activity1710.component.html',
  styleUrls: [ './activity1710.component.scss' ],
} )
export class Activity1710Component implements OnInit {
  @ViewChild( 'fdiv' ) fdiv: ElementRef;
  cityList = [
    { id: '110100', name: '北京' },
    { id: '310100', name: '上海' },
    { id: '330100', name: '杭州' },
    { id: '440300', name: '深圳' },
    { id: '510100', name: '成都' },
    { id: '420100', name: '武汉' },
    { id: '360100', name: '南昌' },
    { id: '610100', name: '西安' },
    { id: '500100', name: '重庆' }
  ];
  Cooperative: any = []; //合作的企业
  moredisplay: boolean = false; //更多企业
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  jobList: any = []; //岗位列表接口
  city_id: any = ''; //城市id
  num: any = 10; //每页显示的条数
  selectcity: any = 'all'; //选择的城市
  constructor(
    private _service: Activity1710Service
  ) { }

  @HostListener( 'click' )
  test() {
    console.log( this.fdiv );
  }
  show( el ) {
    el.toggle(event);
  }
  ngOnInit() {

    //获取所有城市岗位
    this.cityAll();

    //获取合作企业高校
    this._service.getCooperData( '0' ).then( resp => {
      if ( resp[ 'data' ] && resp[ 'data' ].length > 0 ) {
        this.Cooperative = resp[ 'data' ];
      }
    } );
  }
  // 选择全国
  cityAll() {
    this.jobList = [];
    this.selectcity = 'all';
    this._service.getJobsList( this.city_id, this.num ).then( data => {
      if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
        this.jobList = data[ 'data' ];
        this.jobList.map( row => {
          row.welfare === '' ? row.welfare = null : row.welfare = row.welfare.split( "," ); //福利数据处理
        } );
      }
    } );
  }

  //选择城市
  cityFilter( cityid ) {

    let a = this.cityList.find( row => row.id === cityid );
    if ( a ) {
      this.selectcity = a.id;
    }

    this.jobList = [];
    this._service.getJobsList( cityid, this.num ).then( data => {
      if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
        this.jobList = data[ 'data' ];
        this.jobList.map( row => {
          row.welfare === '' ? row.welfare = null : row.welfare = row.welfare.split( "," ); //福利数据处理
        } );
      }
    } );

  }

  //更多企业
  marecom() {
    this.moredisplay = true;
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/activity1710/activity1710.component.ts